import { DecodeName, EncodeName } from "./format-value";

const SetDataToken = (value) => {
    localStorage.setItem("tkd", value);
};

const GetDataToken = () => {
    return (!localStorage.getItem("tkd")) ? null : localStorage.getItem("tkd");
};

const SetDataRefreshToken = (value) => {
    localStorage.setItem("rfd", value);
};

const GetDataRefreshToken = () => {
    return (!localStorage.getItem("rfd")) ? null : localStorage.getItem("rfd");
};

const SetDataMenuData = (value) => {
    localStorage.setItem("mnd", btoa(JSON.stringify(value)));
};

const GetDataMenuData = () => {
    return (!localStorage.getItem("mnd")) ? null : localStorage.getItem("mnd");
};

const SetDataUserID = (value) => {
    localStorage.setItem("uid", btoa(value));
};

const GetDataUserID = () => {
    return (!localStorage.getItem("uid")) ? null : atob(localStorage.getItem("uid"));
};

// ── "ugd": id_user_group จริงของ user คนนี้ (ตอน login) ── ห้ามถูกเขียนทับตอนสลับ role ดู ──
// ── เพราะใช้ตัดสินสิทธิ์ว่า "ตัวจริง" เป็น admin หรือเปล่า (ใช้โชว์ปุ่มสลับ role ใน DdlProfile.jsx) ──
const SetDataUserGroup = (value) => {
    localStorage.setItem("ugd", btoa(value));
};

const GetDataUserGroup = () => {
    return (!localStorage.getItem("ugd")) ? null : atob(localStorage.getItem("ugd"));
};

// ── FIX: "aug" (active user group) = id_user_group ที่ "กำลังสวมบทบาทดูอยู่ตอนนี้" ──
// ── แยกออกจาก "ugd" (ตัวจริง) โดยเฉพาะ เพราะ admin (ugd=2) กด "สลับไปดูเป็น User" ได้ ──
// ── แต่ user จริง (ugd=1) ต้องสลับไม่ได้เลย ── ถ้าใช้ "ugd" ตัวเดียวคุมทั้งสิทธิ์สลับและเมนูที่เห็น ──
// ── พอสลับแล้วเขียนทับ "ugd" จะทำให้ admin กลายเป็น "user จริง" ไปเลย สลับกลับไม่ได้อีก (บั๊กที่เจอ) ──
// ── GetDataActiveUserGroup คืนค่า "aug" ถ้ามี ไม่งั้น fallback เป็น "ugd" (ค่าเริ่มต้นตอนยังไม่เคยสลับ) ──
const SetDataActiveUserGroup = (value) => {
    localStorage.setItem("aug", btoa(value));
};

const GetDataActiveUserGroup = () => {
    return (!localStorage.getItem("aug")) ? GetDataUserGroup() : atob(localStorage.getItem("aug"));
};

const SetDataEmail = (value) => {
    localStorage.setItem("emd", btoa(value));
};

const GetDataEmail = () => {
    return (!localStorage.getItem("emd")) ? null : atob(localStorage.getItem("emd"));
};

const SetDataFullName = (value) => {
    localStorage.setItem("fln", EncodeName(value));
};

const GetDataFullName = () => {
    return (!localStorage.getItem("fln")) ? null : DecodeName(localStorage.getItem("fln"));
};

export {
    SetDataToken, GetDataToken,
    SetDataRefreshToken, GetDataRefreshToken,
    SetDataMenuData, GetDataMenuData,
    SetDataUserGroup, GetDataUserGroup,
    SetDataActiveUserGroup, GetDataActiveUserGroup,
    SetDataEmail, GetDataEmail,
    SetDataFullName, GetDataFullName,
    SetDataUserID, GetDataUserID,
};